module.exports = __webpack_public_path__ + "resource/static/img/icon10@1.5x.c5797d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/icon10@1.5x.png
// module id = JSHx
// module chunks = 1